import { LocalLoadingSpinner } from "@/components/Layout/LoadingSpinner/LoadingSpinner";
import { ManualKeyField } from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/ManualKeyField";

export const TwoFactorManualQrCodeField = ({
  manualCode,
}: {
  manualCode?: string;
}) => {
  if (!manualCode) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LocalLoadingSpinner />
      </div>
    );
  }

  return <ManualKeyField manualCode={manualCode} />;
};
